import React, { useState, useEffect } from 'react'
import $ from 'jquery';
import notificationSVG from '../../asset/Images/notification-text.svg';
import dotsSVG from '../../asset/Images/dots-vertical.svg';
import { getAssetAUM } from '../../actions/assetDetailsActions';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom'


export const AssetsList = (previousMonthEndDate) => {
    const currentDate = new Date();
    const previousMonth = currentDate.getMonth() - 1;
    const previousMonthEndDateLocal = new Date(currentDate.getFullYear(), previousMonth + 1, 0);
    const PDate = (previousMonthEndDateLocal).toISOString();
    const dispatch = useDispatch();
    const params = useParams();
    const AssetAUM = useSelector((state) => state.assetAUM.assetAUM);
    useEffect(() => {
        dispatch(getAssetAUM(params.Asset, PDate));
    }, []);
    return(

      
          
                        <div class="card-body p-0">

                    <div class="row p-3 border-bottom  m-0">
                        <div class="col-6 left">
                            <span>Asset</span>
                        </div>
                        <div class="col-6 text-sm-end fw-medium">
                            <span>{AssetAUM && AssetAUM[0]?.AssetValue ? '$' + AssetAUM[0].AssetValue.toLocaleString('en-US') +  ' '+'MM' : 'NA'}</span>
                        </div>
                    </div>
                    <div class="row p-3 border-bottom  m-0">
                        <div class="col-6 left">
                            <span>Strategy</span>
                        </div>
                        <div class="col-6 text-sm-end fw-medium">
                            <span>{ AssetAUM && AssetAUM[0]?.StrategyValue ? '$' + AssetAUM[0].StrategyValue.toLocaleString('en-US') +  ' '+'MM' : 'NA'}</span>
                        </div>
                    </div>
                    <div class="row p-3 m-0">
                        <div class="col-6 left">
                            <span>Firm</span>
                        </div>
                        <div class="col-6 text-sm-end fw-medium">
                        
                            <span>{AssetAUM && AssetAUM[0]?.FirmValue ? '$' + AssetAUM[0].FirmValue.toLocaleString('en-US') +  ' '+'MM' : 'NA'}</span>
                        </div>
                    </div>
                            </div>

                                              

               
        )
    }
    